(function () {
  'use strict';

  var API = (typeof VINYL_API_BASE_URL !== 'undefined' && VINYL_API_BASE_URL) || '';
  var MARKETS = ['GLOBAL', 'US', 'AU', 'CA', 'GB'];
  var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Display "YYYY-MM" as "Mon YYYY" (e.g. "2026-06" → "Jun 2026"). The raw
  // "YYYY-MM" value is still what drives URL state / API calls; this only
  // changes what the shopper sees. Returns the input unchanged if malformed.
  function formatMonth(m) {
    if (!m) return '';
    var parts = String(m).split('-');
    var year = parts[0];
    var monthIndex = parseInt(parts[1], 10) - 1;
    if (!year || isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) return m;
    return MONTH_NAMES[monthIndex] + ' ' + year;
  }
  // Visitor's country (for pricing/currency), independent of the chart market.
  // Shopify exposes the active country on the global Shopify object; default US.
  var COUNTRY = (typeof Shopify !== 'undefined' && Shopify && Shopify.country) || 'US';

  var root = document.getElementById('vinyl-charts');
  if (!root) return;

  var els = {
    tabs: Array.prototype.slice.call(root.querySelectorAll('.vc-tab')),
    monthValue: document.querySelector('#vc-month .vc-month-value'),
    monthMenu: document.getElementById('vc-month-menu'),
    share: document.getElementById('vc-share'),
    list: document.getElementById('vc-list'),
    skeleton: document.getElementById('vc-skeleton'),
    empty: document.getElementById('vc-empty'),
    modal: document.getElementById('vc-modal'),
  };

  var state = { market: 'GLOBAL', month: null };

  // ---- URL / tab state (Task 2) ------------------------------------------

  function readState() {
    var params = new URLSearchParams(window.location.search);
    var market = (params.get('market') || '').toUpperCase();
    state.market = MARKETS.indexOf(market) !== -1 ? market : (root.dataset.defaultMarket || 'GLOBAL');
    state.month = params.get('month') || null; // resolved against available months later
  }

  function writeState() {
    var params = new URLSearchParams(window.location.search);
    params.set('market', state.market);
    if (state.month) params.set('month', state.month);
    var url = window.location.pathname + '?' + params.toString();
    window.history.replaceState({}, '', url);
  }

  function setActiveTab() {
    els.tabs.forEach(function (tab) {
      tab.setAttribute('aria-pressed', tab.dataset.market === state.market ? 'true' : 'false');
    });
  }

  async function loadMonths() {
    var res = await fetch(API + '/charts/months');
    var body = await res.json();
    var months = (body && body.data) || [];
    // Build Bootstrap dropdown items (matches search/shop .sort-dropdown markup).
    els.monthMenu.innerHTML = '';
    months.forEach(function (m) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'dropdown-item';
      a.href = '#';
      a.textContent = formatMonth(m);
      a.dataset.month = m;
      li.appendChild(a);
      els.monthMenu.appendChild(li);
    });
    // Resolve month: keep URL month if valid, else newest available.
    if (months.indexOf(state.month) === -1) {
      state.month = months[0] || null;
    }
    updateMonthLabel();
    return months;
  }

  function updateMonthLabel() {
    if (els.monthValue) els.monthValue.textContent = formatMonth(state.month) || 'Month';
  }

  // ---- Fetch + render (Task 3) -------------------------------------------

  function showLoading(isLoading) {
    els.skeleton.hidden = !isLoading;
    if (isLoading) { els.list.innerHTML = ''; els.empty.hidden = true; }
  }

  // Mirror of scripts/Component/ProductItem/ProductItem.js title parsing:
  // split only on the first " - " → artist (before) / album name (after).
  // When the title has no " - ", the artist is looked up from the "artist:" tag,
  // falling back to the API-provided artist field.
  function customDecodeURI(text) {
    try {
      return decodeURIComponent(text);
    } catch (err) {
      return text;
    }
  }

  function parseTitle(product) {
    var title = product.title || '';
    var tags = product.tags || [];
    var fPart = title;
    var sPart = '';

    var dashIndex = title.indexOf(' - ');
    if (dashIndex !== -1) {
      fPart = title.slice(0, dashIndex);
      sPart = title.slice(dashIndex + 3); // +3 to skip " - "
    }

    var name = sPart || fPart;

    // if no artist in title => find in tags
    if (!sPart) {
      var artistTag = tags.find(function (tag) {
        return tag.toLowerCase().indexOf('artist:') !== -1;
      });
      var _artist = (artistTag || '').split(':')[1];
      fPart = _artist && _artist.trim() !== '' ? _artist.trim() : (product.artist || '');
    }

    return { name: name, artist: customDecodeURI(fPart) };
  }

  // Prefix the amount with a currency symbol → "$25.98" (matches the product
  // pages / perfect-pairings modal, which use app.getCurrency() from all.js).
  function formatPrice(price) {
    if (!price || price.amount == null) return '';
    var amount = parseFloat(price.amount);
    if (isNaN(amount)) return '';
    if (typeof app !== 'undefined' && app && typeof app.getCurrency === 'function') {
      return app.getCurrency() + amount.toFixed(2);
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: price.currencyCode || 'USD',
      }).format(amount);
    } catch (err) {
      return amount.toFixed(2) + ' ' + (price.currencyCode || '');
    }
  }

  function movementHtml(rank, previousRank) {
    if (previousRank === null || previousRank === undefined) {
      return '<span class="vc-new">NEW</span>';
    }
    if (previousRank > rank) return '<span class="vc-move-up" aria-label="up">▲</span>';
    if (previousRank < rank) return '<span class="vc-move-down" aria-label="down">▼</span>';
    return '<span class="vc-move-same" aria-label="no change">=</span>';
  }

  async function fetchChart() {
    var url = API + '/charts?market=' + encodeURIComponent(state.market) + '&month=' + encodeURIComponent(state.month);
    var res = await fetch(url);
    var body = await res.json();
    return (body && body.data) || [];
  }

  async function fetchProducts(ids) {
    if (!ids.length) return {};
    var url = API + '/products?ids=' + encodeURIComponent(ids.join(',')) + '&country=' + encodeURIComponent(COUNTRY);
    var res = await fetch(url);
    var body = await res.json();
    var map = {};
    ((body && body.data) || []).forEach(function (p) { map[p.id] = p; });
    return map;
  }

  function renderRows(entries, products) {
    els.list.innerHTML = '';
    if (!entries.length) { els.empty.hidden = false; return; }
    els.empty.hidden = true;

    entries.forEach(function (entry) {
      var p = products[entry.productId] || {};
      var li = document.createElement('li');
      li.className = 'vc-row';
      var prev = entry.previousRank === null ? '—' : entry.previousRank;
      var parsed = parseTitle(p);
      li.innerHTML =
        '<span class="vc-move">' + movementHtml(entry.rank, entry.previousRank) + '</span>' +
        '<span class="vc-rank">' + entry.rank + '</span>' +
        '<img class="vc-cover" src="' + (p.imageUrl || '') + '" alt="' + (p.title || '') + '" loading="lazy">' +
        '<span class="vc-meta"><a class="vc-name" href="/products/' + (p.handle || '') + '">' + (parsed.name || '') + '</a>' +
          '<span class="vc-artist">' + (parsed.artist || '') + '</span></span>' +
        '<span class="vc-lastmonth">' + prev + '</span>' +
        '<span class="vc-months">' + entry.monthsOnChart + '</span>' +
        '<div class="react-wishlist-icon" data-product-id="' + wishlistId(entry.productId) + '" data-product-price="' + (p.price ? p.price.amount : '') + '"></div>' +
        '<button class="vc-more" type="button" data-product-id="' + entry.productId + '" aria-label="More info">+</button>';
      els.list.appendChild(li);
    });
  }

  // Wishlist expects the Shopify numeric product id (see Task 4). Format here.
  function wishlistId(productId) {
    var m = String(productId).match(/(\d+)$/);
    return m ? m[1] : productId;
  }

  // ---- Wishlist + cart (Task 4) ------------------------------------------

  function hydrateWishlist() {
    if (typeof shopifyCustomer !== 'undefined' && typeof shopifyCustomer.addWishlistIcon === 'function') {
      shopifyCustomer.addWishlistIcon();
    }
  }

  // Fallback add-to-cart used only when the site-wide app.handleBuyClick isn't available.
  // Mirrors its events so the React cart drawer still refreshes + opens.
  async function fallbackAddToCart(product) {
    var variantId = product && product.variantId;
    if (!variantId) return;
    var m = String(variantId).match(/(\d+)$/);
    var id = m ? m[1] : variantId;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      });
      var data = await res.json();
      document.dispatchEvent(new CustomEvent('vinyl:cart:refresh', { detail: { addedItems: data.items } }));
      var toggle = document.getElementById('cart-toggle-button');
      if (toggle) toggle.click();
    } catch (e) {
      document.dispatchEvent(new CustomEvent('vinyl:cart:adding:end'));
    }
  }

  // ---- Detail modal (Task 5) ---------------------------------------------

  function openModal(entry, product) {
    var parsed = parseTitle(product);
    var purchasable = !!(product.availableForSale && product.variantId);
    // In stock → the charts Add to cart button. Out of stock → render the
    // theme's sold-out product button (.button-buy.sold-out with a numeric
    // data-product-id + .price-now). The vinyl-app "notify-me" app embed
    // (target: body, so it runs here too) swaps that for its "Notify me"
    // button when we fire react:products:rendered below — same flow as the PDP.
    var ctaHtml = purchasable
      ? '<button class="vc-add-to-cart button-buy" type="button" ' +
          'data-variant-id="' + (product.variantId || '') + '" ' +
          'data-tracking-from="vinyl-charts" ' +
          'data-price="' + (product.price ? product.price.amount : '') + '" ' +
          'data-image-src="' + (product.imageUrl || '') + '">ADD TO CART</button>'
      : '<button class="vc-oos-btn button-buy btn btn-light disabled sold-out" type="button" ' +
          'data-product-id="' + wishlistId(entry.productId) + '" disabled>' +
          '<span class="price-now">' + formatPrice(product.price) + '</span>' +
          '<span class="buy-now">OUT OF STOCK</span></button>' +
        '<p class="vc-oos-message product-quantity-low-stock">Out of stock. Get notified when available.</p>';
    els.modal.innerHTML =
      '<div class="vc-modal-card" role="dialog" aria-modal="true">' +
        '<button class="vc-modal-close" type="button" aria-label="Close">×</button>' +
        '<img class="vc-modal-cover" src="' + (product.imageUrl || '') + '" alt="' + (product.title || '') + '">' +
        '<div class="vc-modal-body">' +
          '<h2 class="vc-modal-title">' + (parsed.name || '') + '</h2>' +
          '<p class="vc-modal-artist">' + (parsed.artist || '') + '</p>' +
          '<div class="vc-modal-desc-wrap">' +
            '<div class="vc-modal-desc vc-clamped">' + (product.description || '') + '</div>' +
            '<a href="#" class="vc-modal-readmore" role="button">Read more</a>' +
          '</div>' +
          '<div class="vc-modal-stats">' +
            '<div class="vc-stat"><span class="vc-stat-num"># ' + entry.rank + '</span><span class="vc-stat-label">CURRENT</span></div>' +
            '<div class="vc-stat"><span class="vc-stat-num">' + entry.monthsOnChart + '</span><span class="vc-stat-label">CHART MONTHS</span></div>' +
          '</div>' +
          '<p class="vc-modal-price">' + formatPrice(product.price) + '</p>' +
          ctaHtml +
          '<a class="vc-modal-link" href="/products/' + (product.handle || '') + '">View Full Product Page</a>' +
        '</div>' +
      '</div>';
    els.modal.hidden = false;

    els.modal.querySelector('.vc-modal-close').addEventListener('click', closeModal);
    var addBtn = els.modal.querySelector('.vc-add-to-cart');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        // Keep the modal open so the button runs its "Adding… → Added ✓"
        // loading state (the site-wide VinylAddToCart feedback, same as the
        // PDP). Close only once the add lands and the cart drawer takes over.
        document.addEventListener('vinyl:cart:refresh', function onAdded() {
          document.removeEventListener('vinyl:cart:refresh', onAdded);
          closeModal();
        });
        // Reuse the site-wide add-to-cart flow (opens the cart drawer, updates the
        // header count, fires tracking) — same handler product cards + search use.
        if (typeof app !== 'undefined' && app && typeof app.handleBuyClick === 'function') {
          app.handleBuyClick.call(addBtn, e);
        } else {
          fallbackAddToCart(product);
        }
      });
    }

    // Read more / show less — mirrors the perfect-pairings modal behaviour:
    // clamp the description and only offer the toggle when it actually overflows.
    var desc = els.modal.querySelector('.vc-modal-desc');
    var readMore = els.modal.querySelector('.vc-modal-readmore');
    if (desc && readMore) {
      var overflows = desc.scrollHeight > desc.clientHeight + 1;
      if (!overflows) {
        readMore.hidden = true;
        desc.classList.remove('vc-clamped');
      } else {
        readMore.addEventListener('click', function (e) {
          e.preventDefault();
          var clamped = desc.classList.toggle('vc-clamped');
          readMore.textContent = clamped ? 'Read more' : 'Show less';
        });
      }
    }
    els.modal.addEventListener('click', function onBackdrop(e) {
      if (e.target === els.modal) { closeModal(); els.modal.removeEventListener('click', onBackdrop); }
    });

    // Out of stock: let the vinyl-app notify-me embed convert the sold-out
    // button into its "Notify me" button (opens the back-in-stock modal, or
    // auto-subscribes for logged-in customers) — identical to the product page.
    if (!purchasable) {
      document.dispatchEvent(
        new CustomEvent('react:products:rendered', { detail: { name: 'VinylCharts' } })
      );
    }
  }

  function closeModal() {
    els.modal.hidden = true;
    els.modal.innerHTML = '';
  }

  // ---- Wiring (Task 5) ---------------------------------------------------

  var lastEntries = [];
  var lastProducts = {};

  async function refresh() {
    writeState();
    setActiveTab();
    showLoading(true);
    var entries = await fetchChart();
    var products = await fetchProducts(entries.map(function (e) { return e.productId; }));
    lastEntries = entries; lastProducts = products;
    showLoading(false);
    renderRows(entries, products);
    hydrateWishlist();
  }

  function bindEvents() {
    els.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { state.market = tab.dataset.market; refresh(); });
    });
    els.monthMenu.addEventListener('click', function (e) {
      var item = e.target.closest('.dropdown-item');
      if (!item) return;
      e.preventDefault();
      if (item.dataset.month === state.month) return;
      state.month = item.dataset.month;
      updateMonthLabel();
      refresh();
    });
    els.share.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) { navigator.share({ url: url }); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(url); }
    });
    els.list.addEventListener('click', function (e) {
      var btn = e.target.closest('.vc-more');
      if (!btn) return;
      var entry = lastEntries.find(function (en) { return en.productId === btn.dataset.productId; });
      if (entry) openModal(entry, lastProducts[entry.productId] || {});
    });
  }

  async function init() {
    readState();
    await loadMonths();
    bindEvents();
    if (!state.month) { showLoading(false); els.empty.hidden = false; return; }
    await refresh();
  }

  init();
})();
